'use client';

import { useTranslations } from 'next-intl';

import { ProductModalVariantProduct } from '@/feature/product-modal-variant';
import { shouldShowSizeSelector } from '@/feature/product-modal-variant/utils/shouldShowSizeSelector';
import { UiProductCounterInput } from '@/ui/product-counter-input';
import { UiKitButton } from '@/ui-kit/button';

import { ProductVariantSelector } from '../ProductVariantSelector/ProductVariantSelector';

import { styles } from './CartItemEdit.styles';

export interface CartItemEditProps {
  selectedVariantId: string | null;
  onVariantClick: (variantId: string) => void;
  onSelect: () => void;
  product: ProductModalVariantProduct;
  quantity: number;
  onQuantityChange: (quantity: number) => void;
  maxOfferQuantity?: number;
  minQuantity?: number;
  loading?: boolean;
}

export function CartItemEdit({
  product,
  selectedVariantId,
  onVariantClick,
  onSelect,
  quantity,
  onQuantityChange,
  maxOfferQuantity,
  minQuantity = 0,
  loading = false
}: CartItemEditProps) {
  const t = useTranslations();
  const slots = styles();

  const showSizeSelector = shouldShowSizeSelector(product.productOffers);
  const isButtonDisabled = !selectedVariantId;

  return (
    <div className={slots.base()}>
      {showSizeSelector && (
        <div className={slots.section()}>
          <h3 className={slots.sectionTitle()}>{t('productVariantModal.size')}</h3>
          <ProductVariantSelector
            variants={product.productOffers}
            selectedVariantId={selectedVariantId}
            onVariantClick={onVariantClick}
          />
        </div>
      )}

      <div className={slots.section()}>
        <h3 className={slots.sectionTitle()}>{t('productVariantModal.count')}</h3>

        <UiProductCounterInput
          className={slots.quantity()}
          value={quantity}
          onChange={onQuantityChange}
          max={maxOfferQuantity}
          min={minQuantity}
          hideDeleteIcon={minQuantity > 0}
          loading={loading}
        />

        <UiKitButton
          className={slots.selectButton()}
          disabled={isButtonDisabled}
          onClick={onSelect}
        >
          {t('productVariantModal.select')}
        </UiKitButton>
      </div>
    </div>
  );
}
